/**
 * @description : Delete Popup
 * @author : Naga Vineela
 * @date : 01-12-2023
 * */

/* Import Components and Functions Here */
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AiOutlineWarning } from 'react-icons/ai';
import styles from './popups.module.scss';

function DeletePopup(props) {
  const handleClose = () => {
    props.close(true);
  };

  const handleClick = () => {
    props.yes(true);
    props.close(true);
  };

  return (
    <>
      <Modal size="sm" show={props.show} onHide={handleClose} centered>
        <Modal.Body className="text-center">
          <AiOutlineWarning className={styles.alertWarningIcon} />
          <h5>
            Do you want to delete this row{' '}
            {props.channel &&
              props.channel + ' > ' + props.category + ' > ' + props.name}
            ?
          </h5>
        </Modal.Body>
        <Modal.Footer className="mt-1 d-flex justify-content-center">
          <Button
            style={{ minWidth: '75px' }}
            variant="outline-primary"
            onClick={handleClose}
          >
            No
          </Button>
          <Button
            style={{ minWidth: '75px' }}
            variant="primary"
            onClick={handleClick}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default DeletePopup;
